
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";
import { Row, Col } from "antd";
import { getStrapiMedia } from "../../../helpers/tranformers";

const Client = ({ content }) => {
  
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const logoUrls = content?.logos?.map((logo) => getStrapiMedia(logo.url));

  return (
    <div className="section-content" style={{ maxWidth: "90%" }}>
      <div
        className="section-heading center-text"
        data-aos="fade-up"
        data-aos-duration="700"
      >
        {/* Who We Work With{" "}*/}
        {content?.Title}
      </div>
      {!isMobile ? (
        <Swiper
          loop={true}
          spaceBetween={20}
          slidesPerView={5}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
          className="mySwiper"
        >
          {logoUrls?.map((logo, index) => (
            <SwiperSlide key={index} className="client-logo-img-wrapper">
              <img
                src={logo}
                alt={`client-logo-${index}`}
                className="client-logo-img"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <div style={{ padding: "0px 25px", marginTop: "50px" }}>
          <Row gutter={[15, 15]} justify="center">
            {logoUrls?.map((logo, index) => (
              <Col span={12} key={index} className="client-logo-img-wrapper">
                <img
                  src={logo}
                  alt={`client-logo-${index}`}
                  className="client-logo-img"
                />
              </Col>
            ))}
          </Row>
        </div>
      )}
    </div>
  );
};

export default Client;
